namespace Nobox {
    export interface DashboardBroadcastPageModel {
        Queue?: number;
        Process?: number;
        Sent?: number;
        Failed?: number;
        Canceled?: number;
        Total?: number;
        BroadcastSent?: Nobox.Nobox.Pages.campaignGroup[];
        LastSentMessages?: latestSentMessage[];
    }
}
